import React from 'react';
import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';
import { Icon, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { NODE_DATA_MODEL } from '../../../models/CertsModels';
import { getMessageKey } from '../../../utils/utils';

import './TrustJustification.css';

const ROW_TYPE = {
  ROLE: 'Role',
  ENTITLEMENT: 'Entitlement',
};

const RISK_KINDS = {
  warning: 'warning-700',
  success: 'success-700',
  critical: 'critical-700',
  info: 'navy-900',
};

function TrustJustification({ isTrustScoreEnabled, nodeData, certsKind }) {
  const intl = useIntl();

  if (isTrustScoreEnabled) {
    if (isTrustScoreEnabled?.enableCertificationTrustModel) {
      const trustJustification = nodeData?.TRUST_JUSTIFICATION || [
        { 'CR.JRM.NO_RULES_FOUND.Reason.Default.label': [] },
      ];

      return (
        Array.isArray(trustJustification) &&
        trustJustification?.map((item) => {
          const reasonKeys = Object.keys(item);
          const firstKey = reasonKeys.length > 0 ? reasonKeys[0] : undefined;
          const firstKeyValue =
            item[firstKey]?.map((value) => value.toFixed(2)) || [];

          if (firstKey) {
            return (
              <div key={firstKey} className='TrustJustification-listItem'>
                <Icon
                  kind='AlertInfo'
                  size='small'
                  color={RISK_KINDS.info}
                  className='TrustJustification-listItemIcon'
                />
                <Typography
                  kind='body2'
                  className='TrustJustification-listItemText'>
                  {localize(intl, firstKey, firstKeyValue)}
                </Typography>
              </div>
            );
          }

          return '';
        })
      );
    }

    if (nodeData?.JRMRULES?.rmd === 'POSSIBLE_REJECTION') {
      const reasonMessage =
        typeof nodeData?.TRUST_JUSTIFICATION === 'string'
          ? nodeData?.TRUST_JUSTIFICATION
          : "None of the user's attributes correspond to this entitlement";

      return (
        <div className='TrustJustification-listItem'>
          <Icon
            kind='AlertInfo'
            size='small'
            color={RISK_KINDS.info}
            className='TrustJustification-listItemIcon'
          />
          <Typography kind='body2' className='TrustJustification-listItemText'>
            {certsKind === ROW_TYPE.ROLE
              ? reasonMessage
                  ?.replace('Entitlement', 'role')
                  ?.replace('entitlement', 'role')
              : reasonMessage}
          </Typography>
        </div>
      );
    }

    return nodeData?.JRMRULES?.rmd === 'NO_OPINION' ? (
      <div className='TrustJustification-listItem'>
        <Icon
          kind='AlertInfo'
          size='small'
          color={RISK_KINDS.info}
          className='TrustJustification-listItemIcon'
        />
        <Typography kind='body2' className='TrustJustification-listItemText'>
          {localize(intl, getMessageKey(nodeData?.JRMRULES?.rmd))}
        </Typography>
      </div>
    ) : (
      <div className='TrustJustification-listItem'>
        <Icon
          kind='AlertInfo'
          size='small'
          color={RISK_KINDS.info}
          className='TrustJustification-listItemIcon'
        />
        <Typography kind='body2' className='TrustJustification-listItemText'>
          {nodeData?.JRMRULES?.rsn?.replace('Entitlement', 'role') ||
            nodeData?.JSON_JRMRULESAVAILABLE}
        </Typography>
      </div>
    );
  }

  return null;
}

TrustJustification.propTypes = {
  isTrustScoreEnabled: PropTypes.shape({
    enableCertificationTrustModel: PropTypes.bool,
  }),
  nodeData: PropTypes.shape(NODE_DATA_MODEL).isRequired,
  certsKind: PropTypes.string.isRequired,
};

TrustJustification.defaultProps = { isTrustScoreEnabled: {} };

export default TrustJustification;
